import { KibTopLevelAlert } from '@chewy/kib-messaging-react'

import '@chewy/kib-messaging-styles/dist/styles/kib-alert-icon.css'
import '@chewy/kib-messaging-styles/dist/styles/kib-top-level-alert.css'
import styles from './CancelSuccessBanner.module.scss'

interface CancelSuccessBannerProps {
  message: string
}

export const CancelSuccessBanner = ({ message }: CancelSuccessBannerProps) => {
  if (!message) {
    return null
  }

  return (
    <KibTopLevelAlert
      className={styles.cancelSuccessBanner}
      heading={message}
      severity="success"
    />
  )
}
